export default __webpack_public_path__ + "static/media/SVGOnlineTest.f62981fa.svg";